/* VialArt — guided builder walkthrough v3 (stationary, inline).
   Order the customer actually wants: compound -> mg -> exp? -> custom line?
   -> logo? -> THEN pick the design.
   As soon as name + dose are set on step 1, a sticky bar walks through the
   optional extras with INLINE inputs (typed right in the bar, written into
   the real Personalize fields underneath) — the page NEVER moves. The final
   step is one tap: "Show designs", the only scroll in the whole pass.
   If the customer bypasses step 1 (e.g. taps a design first), nothing runs —
   the Personalize form is right there anyway. One pass per session.
   Fail-open everywhere. VialArt theme. */
(function () {
  var PH = { 'va-name': 'Your Compound', 'va-dose': 'Dose' };
  var DONE_KEY = 'va_wt_done';
  var bar = null, idx = 0, started = false;

  var STEPS = [
    { id: 'va-exp', fld: 'va-exp-fld', q: 'Add an expiration date?', sub: 'Optional — prints small on the label', ph: 'e.g. 06/2027', max: 12 },
    { id: 'va-lot', fld: 'va-lot-fld', q: 'Add a custom line of text?', sub: 'Optional — a batch #, a note, anything', ph: 'e.g. Batch 2406', max: 22 },
    { logo: true, q: 'Add your logo?', sub: 'Optional — makes it a branded label (+15%)' },
    { final: true, q: 'All set — now pick your design', sub: 'Your text appears on every design below' }
  ];

  function $(id) { return document.getElementById(id); }
  function val(id) { var e = $(id); var v = e ? (e.value || '').trim() : ''; return (v && v !== PH[id]) ? v : ''; }
  function done() { try { return sessionStorage.getItem(DONE_KEY) === '1'; } catch (e) { return false; } }
  function markDone() { try { sessionStorage.setItem(DONE_KEY, '1'); } catch (e) {} }
  function step1Active() {
    var s = document.querySelector('.va-step[data-step="1"]');
    return s && s.classList.contains('active');
  }

  function writeField(id, fldId, v) {
    var inp = $(id); if (!inp) return false;
    var fld = $(fldId), add = fld && fld.querySelector('.va-fld-add');
    if (add && !add.hidden) { try { add.click(); } catch (e) {} }
    inp.value = v;
    try {
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
    return true;
  }

  function ensureCss() {
    if ($('va-wt-css')) return;
    var st = document.createElement('style'); st.id = 'va-wt-css';
    st.textContent =
      '.va-wt{position:fixed;left:10px;right:10px;bottom:10px;z-index:9000;display:flex;align-items:center;gap:10px;flex-wrap:wrap;'
      + 'background:linear-gradient(120deg,#1c1140,#241653);border:1px solid rgba(124,77,255,.6);border-radius:14px;'
      + 'padding:11px 13px;box-shadow:0 12px 34px rgba(10,4,25,.55);max-width:680px;margin:0 auto;}'
      + '@media(min-width:980px){.va-wt{left:50%;right:auto;transform:translateX(-50%);width:640px;}}'
      + '.va-wt-q{flex:1 1 180px;min-width:0;color:#fff;font-weight:800;font-size:14.5px;line-height:1.2;}'
      + '.va-wt-q span{display:block;color:#c3b8e8;font-weight:600;font-size:11.5px;margin-top:2px;}'
      + '.va-wt-dots{display:flex;gap:5px;}'
      + '.va-wt-dot{width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.25);}'
      + '.va-wt-dot.on{background:#a98bff;}.va-wt-dot.done{background:#4ade80;}'
      + '.va-wt-in{flex:1 1 150px;min-width:130px;background:#14112a;border:1px solid #453a6e;border-radius:9px;'
      + 'color:#fff;font-size:15px;font-weight:600;padding:10px 12px;font-family:inherit;}'
      + '.va-wt-in:focus-visible{outline:2px solid #b9a0ff;}'
      + '.va-wt-btn{border:0;border-radius:10px;padding:10px 15px;font-weight:800;font-size:13.5px;cursor:pointer;'
      + 'background:linear-gradient(120deg,#7c4dff,#9b6bff);color:#fff;white-space:nowrap;}'
      + '.va-wt-skip{background:transparent;border:1px solid rgba(255,255,255,.3);color:#cdbff2;}'
      + '.va-wt-x{background:transparent;border:0;color:#8d82b5;font-size:16px;cursor:pointer;padding:4px 6px;line-height:1;}';
    document.head.appendChild(st);
  }

  function render() {
    if (idx >= STEPS.length) { finish(false); return; }
    var s = STEPS[idx];
    ensureCss();
    if (!bar) {
      bar = document.createElement('div'); bar.className = 'va-wt';
      document.body.appendChild(bar);
    }
    var dots = STEPS.map(function (_, i) {
      return '<span class="va-wt-dot ' + (i < idx ? 'done' : (i === idx ? 'on' : '')) + '"></span>';
    }).join('');
    var mid = '';
    if (s.id) mid = '<input type="text" class="va-wt-in" id="va-wt-in" placeholder="' + s.ph + '" maxlength="' + (s.max || 22) + '" autocomplete="off">';
    var btns = s.final
      ? '<button type="button" class="va-wt-btn va-wt-go">Show designs ↓</button>'
      : (s.logo
        ? '<button type="button" class="va-wt-btn va-wt-logo">Choose logo</button><button type="button" class="va-wt-btn va-wt-skip">Skip</button>'
        : '<button type="button" class="va-wt-btn va-wt-ok">Add</button><button type="button" class="va-wt-btn va-wt-skip">Skip</button>');
    bar.innerHTML = '<div class="va-wt-dots">' + dots + '</div>'
      + '<div class="va-wt-q">' + s.q + '<span>' + s.sub + '</span></div>' + mid + btns
      + '<button type="button" class="va-wt-x" aria-label="Dismiss" title="Dismiss">✕</button>';

    var inp = $('va-wt-in');
    var ok = bar.querySelector('.va-wt-ok');
    if (ok) ok.onclick = function () {
      var v = inp ? (inp.value || '').trim() : '';
      if (v) writeField(s.id, s.fld, v);
      idx++; render();
    };
    if (inp) inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (ok) ok.click(); } });
    var lg = bar.querySelector('.va-wt-logo');
    if (lg) lg.onclick = function () {
      var f = $('va-logo-file');
      if (!f) { idx++; render(); return; }
      var onpick = function () {
        f.removeEventListener('change', onpick);
        setTimeout(function () { if (idx < STEPS.length && STEPS[idx].logo) { idx++; render(); } }, 400);
      };
      f.addEventListener('change', onpick);
      try { f.click(); } catch (e) { idx++; render(); }
    };
    var sk = bar.querySelector('.va-wt-skip');
    if (sk) sk.onclick = function () { idx++; render(); };
    var go = bar.querySelector('.va-wt-go');
    if (go) go.onclick = function () {
      var t = $('va-track') || document.querySelector('.va-ggrid');
      if (t) { try { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
      finish(true);
    };
    var x = bar.querySelector('.va-wt-x');
    if (x) x.onclick = function () { finish(true); };
  }

  function finish(mark) {
    if (mark) markDone();
    else markDone();
    if (bar) { try { bar.remove(); } catch (e) {} bar = null; }
    window.__vaWtActive = false;
  }

  function maybeStart() {
    try {
      if (started || done()) return;
      if (!step1Active()) return;
      if (!val('va-name') || !val('va-dose')) return;
      // skip prompts for anything already filled
      idx = 0;
      while (idx < STEPS.length - 1 && STEPS[idx].id && val(STEPS[idx].id)) idx++;
      started = true;
      window.__vaWtActive = true;
      render();
    } catch (e) { finish(true); }
  }

  function boot() {
    ['va-name', 'va-dose', 'va-pep-other'].forEach(function (id) {
      var e = $(id);
      if (e) e.addEventListener('input', function () { setTimeout(maybeStart, 250); });
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-mg], .va-pepsel, .va-qp-chip')) setTimeout(maybeStart, 350);
    });
    var n = 0;
    (function poll() {
      if (started || done() || n++ > 120) return;
      maybeStart();
      setTimeout(poll, 700);
    })();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
